import { render, staticRenderFns } from "./task-full-info-file-option-button.vue?vue&type=template&id=119fe240&scoped=true"
import script from "./task-full-info-file-option-button.vue?vue&type=script&lang=js"
export * from "./task-full-info-file-option-button.vue?vue&type=script&lang=js"
import style0 from "./task-full-info-file-option-button.vue?vue&type=style&index=0&id=119fe240&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119fe240",
  null
  
)

export default component.exports